// eslint-disable-next-line import/prefer-default-export
export const gtmTriggerEvent = (name, payload) => {
  window.gtmDataLayer = window.gtmDataLayer || [];
  window.gtmDataLayer.push({ event: name, ...payload });
};
